import theme from '@css/theme';
import { Flex } from '@ui-library/misc';
import styled from 'styled-components';

export const Logo = styled.div`
  width: 300px;
  padding: 30px 0 0 30px;
`;

export const LogoContainer = styled(Flex)`
  position: absolute;
`;

export const CommonContainer = styled(Flex).attrs({
  flexDirection: 'row',
})`
  width: 100vw;
  height: 100vh;
  background-color: #f9f9f9;
`;

interface TextProps {
  width?: string;
  fontFamily?: string;
  fontStyle?: string;
  fontWeight?: string;
  fontSize?: string;
  lineHeight?: string;
  color?: string;
}

export const Container = styled.div`
  background-color: #e5e5e5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  height: auto;
`;

export const ContentView = styled(Flex).attrs({
  flexDirection: 'column',
  justifyContent: 'flex-start',
})``;

export const BlendoView = styled.div`
  min-width: 511px;
  height: 455px;
  border: 1px solid #e1e1e1;
  borderradius: 20px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const TitleText = styled.div`
  font-family: Noto Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 36px;

  color: #101836;
`;

export const NormalText = styled.div`
  font-family: Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;

  color: #ffffff;
`;

export const BorderText = styled.div`
  font-family: Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 22px;
  color: ${theme.color.neutral3};
`;

export const CustomText = styled.div<TextProps>`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'Noto Sans')};
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : 'normal')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'normal')};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : '20px')};

  color: ${(props) => (props.color ? props.color : '#60728B')};
  width: ${(props) => props.width};
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.color.neutral1};
  font-size: ${({ theme }) => theme.fontSize.xl};
`;
